import PropTypes from 'prop-types';
import uuid from 'react-uuid';

import { sanitizeURL } from '../../../utils';
import Link from '../../Core/Link';

import { StyledContainer, Wrapper } from './styles';

const BreadCrumbs = ({ className = '', crumbs }) => {
  if (!crumbs) return null;
  return (
    <StyledContainer className={className}>
      <Wrapper className={`no-bullets ${className}`}>
        {crumbs.map(({ label, slug, active }) => {
          return (
            <li key={uuid()}>
              {active ? (
                <Link
                  className="breadcrumb-link remove-svg"
                  to={sanitizeURL(slug)}
                >
                  {label}
                </Link>
              ) : (
                <p>{label}</p>
              )}
            </li>
          );
        })}
      </Wrapper>
    </StyledContainer>
  );
};

BreadCrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  className: PropTypes.string,
};

export default BreadCrumbs;
